import { create } from 'zustand';

import { LoadingStoreType } from './types';

export const useLoadingStore = create<LoadingStoreType>((set, _get) => ({
  isLoading: false,
  isLoadingModalOpen: false,
  startLoading: () => {
    set((state) => ({ ...state, isLoading: true }));
  },
  startLoadingWithTimer: () => {
    set((state) => ({ ...state, isLoading: true }));
    setTimeout(() => {
      set((state) => ({ ...state, isLoading: false }));
    }, 10000);
  },
  stopLoading: () => {
    set((state) => ({ ...state, isLoading: false }));
  },
  setIsLoadingModalOpen: (value) => {
    set((state) => ({ ...state, isLoadingModalOpen: value }));
  },
}));

/**
 *

  const { example, exampleVar: false } = useExampleDataStore((state) => ({
    currentInventory: state.currentInventory,
    newInventory: state.newInventory,
  }));

  const setExample = useExampleDataStore.getState().setExample();

 */
